module.exports = __webpack_public_path__ + "img/mision3.adaccd91.png";